/* POTO VÉTO — Liquid Glass : interactions */
(function () {
  // Apparition douce au scroll
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.pv-reveal:not(.is-in), .pv-stagger:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  // Flèches des carrousels
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pv-rail-dir]');
    if (!btn) return;
    var rail = btn.closest('[data-pv-rail-wrap]').querySelector('[data-pv-rail]');
    var card = rail.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 18 : 280;
    rail.scrollBy({ left: step * Number(btn.dataset.pvRailDir), behavior: 'smooth' });
  });

  // Fiche produit : galerie + onglets Photos / Sommaire / Intérieur
  function initProduct(root) {
    (root || document).querySelectorAll('[data-pv-product]').forEach(function (prod) {
      if (prod.dataset.ready) return;
      prod.dataset.ready = '1';

      var main = prod.querySelector('[data-pv-main-img]');
      prod.querySelectorAll('[data-pv-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          prod.querySelectorAll('[data-pv-thumb]').forEach(function (o) { o.classList.remove('is-active'); });
          t.classList.add('is-active');
          if (main) {
            main.classList.add('is-fading');
            setTimeout(function () {
              main.src = t.dataset.src;
              main.srcset = t.dataset.srcset || '';
              main.classList.remove('is-fading');
            }, 160);
          }
        });
      });

      // Onglets de l'aperçu
      var tabs = prod.querySelectorAll('[data-pv-tab]');
      var panels = prod.querySelectorAll('[data-pv-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.dataset.pvTab;
          tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          panels.forEach(function (p) {
            var on = p.dataset.pvPanel === key;
            p.hidden = !on;
            // Le PDF n'est chargé qu'à la première ouverture de l'onglet
            var frame = p.querySelector('iframe[data-src]');
            if (on && frame && !frame.src) {
              // Navigateurs sans lecteur PDF intégré (Chrome Android…) : bouton d'ouverture à la place
              if (navigator.pdfViewerEnabled === false) {
                p.classList.add('pv-pdf-fallback');
              } else {
                frame.src = frame.dataset.src;
              }
            }
          });
          var ind = prod.querySelector('.pv-tabs__indicator');
          if (ind) { ind.style.width = tab.offsetWidth + 'px'; ind.style.transform = 'translateX(' + tab.offsetLeft + 'px)'; }
        });
      });
      var first = prod.querySelector('[data-pv-tab][aria-selected="true"]');
      if (first) {
        var ind = prod.querySelector('.pv-tabs__indicator');
        requestAnimationFrame(function () {
          if (ind) { ind.style.width = first.offsetWidth + 'px'; ind.style.transform = 'translateX(' + first.offsetLeft + 'px)'; }
        });
      }

      // Variantes (carte cadeau, etc.)
      var idInput = prod.querySelector('[data-pv-variant-id]');
      var priceEl = prod.querySelector('[data-pv-price]');
      var addBtn = prod.querySelector('[data-pv-add]');
      prod.querySelectorAll('[data-pv-variant]').forEach(function (v) {
        v.addEventListener('click', function () {
          prod.querySelectorAll('[data-pv-variant]').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          v.setAttribute('aria-pressed', 'true');
          if (idInput) idInput.value = v.dataset.pvVariant;
          if (priceEl) priceEl.innerHTML = v.dataset.price;
          if (addBtn) {
            var ok = v.dataset.available === 'true';
            addBtn.disabled = !ok;
            addBtn.querySelector('span').textContent = ok ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldout;
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.dataset.pvVariant);
          window.history.replaceState({}, '', url.toString());
        });
      });

      // Quantité
      var qty = prod.querySelector('[data-pv-qty]');
      prod.querySelectorAll('[data-pv-qty-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.pvQtyStep));
          qty.value = n;
        });
      });
    });
  }

  // Barre d'annonce : rotation des messages (visible sur mobile)
  function initAnn(root) {
    (root || document).querySelectorAll('[data-pv-ann]').forEach(function (ann) {
      if (ann.dataset.ready) return;
      ann.dataset.ready = '1';
      var items = ann.querySelectorAll('.pv-ann__item');
      if (items.length < 2) return;
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, Number(ann.dataset.interval) || 4000);
    });
  }

  // Carrousels : retirer le fondu quand on arrive au bout
  function initRails(root) {
    (root || document).querySelectorAll('[data-pv-rail]').forEach(function (rail) {
      function upd() { rail.classList.toggle('is-end', rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4); }
      rail.addEventListener('scroll', upd, { passive: true });
      upd();
    });
  }


  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Titre de l'accueil : découpe en mots pour les faire apparaître un par un
  function initSplit(root) {
    (root || document).querySelectorAll('.pv-hero .pv-h1:not(.pv-split)').forEach(function (h) {
      h.setAttribute('aria-label', h.textContent.replace(/\s+/g, ' ').trim());
      var i = 0;
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (c) {
          if (c.nodeType === 1) { c.setAttribute('aria-hidden', 'true'); walk(c); return; }
          if (c.nodeType !== 3 || !c.textContent.trim()) return;
          var frag = document.createDocumentFragment();
          c.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var w = document.createElement('span');
            w.className = 'pv-word';
            w.setAttribute('aria-hidden', 'true');
            w.style.setProperty('--i', i++);
            w.textContent = part;
            frag.appendChild(w);
          });
          c.parentNode.replaceChild(frag, c);
        });
      })(h);
      h.classList.add('pv-split');
    });
  }

  // Chiffres clés : compteur qui défile quand ils deviennent visibles
  function initCounters(root) {
    var els = (root || document).querySelectorAll('.pv-hero__stat strong:not([data-pv-count])');
    if (calm || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, m = el.dataset.pvCount.match(/^(\D*)(\d+)([\s\S]*)$/);
        var target = Number(m[2]), start = null, dur = 1400;
        (function step(t) {
          if (start === null) start = t;
          var k = Math.min(1, (t - start) / dur);
          el.textContent = m[1] + Math.round(target * (1 - Math.pow(1 - k, 3))) + m[3];
          if (k < 1) requestAnimationFrame(step);
        })(performance.now());
      });
    }, { rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (el) {
      var txt = el.textContent.trim();
      // Pas de compteur pour une note (« 5/5 ») : on n'affiche jamais « 0/5 »
      if (!/^\D*\d+/.test(txt) || txt.indexOf('/') > -1) return;
      el.dataset.pvCount = txt;
      el.parentNode.style.minWidth = el.parentNode.offsetWidth + 'px';
      el.textContent = txt.replace(/\d+/, '0');
      io.observe(el);
    });
  }

  // Carrousels : les cartes arrivent en cascade
  function initStagger(root) {
    (root || document).querySelectorAll('[data-pv-rail]:not(.pv-stagger)').forEach(function (rail) {
      Array.prototype.forEach.call(rail.children, function (c, i) { c.style.setProperty('--i', Math.min(i, 8)); });
      rail.classList.add('pv-stagger');
    });
  }

  // Émoji en tête des étiquettes : on l'isole pour pouvoir l'animer
  var EMOJI = null;
  try { EMOJI = new RegExp('^((?:\\p{Extended_Pictographic}|\\p{Regional_Indicator})(?:\\uFE0F|\\u200D\\p{Extended_Pictographic}|\\p{Regional_Indicator})*)', 'u'); } catch (err) {}
  function initEmoji(root) {
    if (!EMOJI) return;
    (root || document).querySelectorAll('.pv-eyebrow:not([data-pv-emoji])').forEach(function (eb) {
      eb.dataset.pvEmoji = '1';
      var t = eb.firstChild;
      if (!t || t.nodeType !== 3) return;
      var m = t.textContent.match(EMOJI);
      if (!m) return;
      var s = document.createElement('span');
      s.className = 'pv-emoji';
      s.textContent = m[1];
      t.textContent = t.textContent.slice(m[1].length);
      eb.insertBefore(s, t);
    });
  }

  // Ajout au panier : bouton « Ajouté ! » et icône du panier qui rebondit
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (!e || e.source !== 'product-form') return;
      document.querySelectorAll('[data-pv-add], .pv-sticky .pv-btn').forEach(function (btn) {
        var label = btn.querySelector(':scope > span:not(.pv-ripple)') || btn;
        if (btn.dataset.pvAdded) return;
        btn.dataset.pvAdded = label.textContent;
        label.textContent = btn.hasAttribute('data-pv-add') ? '✓ Ajouté !' : '✓ Ajouté';
        btn.classList.add('is-added');
        setTimeout(function () {
          label.textContent = btn.dataset.pvAdded;
          delete btn.dataset.pvAdded;
          btn.classList.remove('is-added');
        }, 2000);
      });
      requestAnimationFrame(function () {
        var cart = document.getElementById('cart-icon-bubble');
        if (!cart) return;
        cart.classList.remove('pv-bump');
        void cart.offsetWidth;
        cart.classList.add('pv-bump');
        setTimeout(function () { cart.classList.remove('pv-bump'); }, 900);
      });
    });
  }

  // Onde au clic sur les boutons
  document.addEventListener('pointerdown', function (e) {
    var btn = !calm && e.target.closest('.pv-btn');
    if (!btn || btn.disabled) return;
    var r = btn.getBoundingClientRect();
    var dot = document.createElement('span');
    dot.className = 'pv-ripple';
    dot.style.setProperty('--x', (e.clientX - r.left) + 'px');
    dot.style.setProperty('--y', (e.clientY - r.top) + 'px');
    dot.style.setProperty('--s', Math.max(r.width, r.height) * 2.2 + 'px');
    dot.addEventListener('animationend', function () { dot.remove(); });
    btn.appendChild(dot);
  });

  function boot(root) { initSplit(root); initEmoji(root); initStagger(root); initReveal(root); initCounters(root); initProduct(root); initAnn(root); initRails(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  // Éditeur de thème : réinitialiser quand une section est rechargée
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
